import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const API_PATH_PATTERN = /\/api\//;

@Injectable()
export class ApiNetworkOnlyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestPath = request.url.split(/[?#]/, 1)[0];
    if (!API_PATH_PATTERN.test(requestPath)) {
      return next.handle(request);
    }

    return next.handle(request.clone({
      setHeaders: {
        'ngsw-bypass': 'true',
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache',
      },
    }));
  }
}
